import { render } from "./ShowView.vue?vue&type=template&id=2024c14a&scoped=true&ts=true"
import script from "./ShowView.vue?vue&type=script&lang=ts"
export * from "./ShowView.vue?vue&type=script&lang=ts"

import "./ShowView.vue?vue&type=style&index=0&id=2024c14a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2024c14a"]])

export default __exports__